import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";

function Notification(props) {
    // const [show, setShow] = useState(true);
    console.log("first", props.kind);
    return (
        props.show && (
            <div>
                <div
                    className={`${props.className} alert bg-[#FBF7FF] rounded-[1.5rem] py-[1.5rem] pr-[1.6rem] pl-[3.6rem] w-11/12 h-full relative`}
                >
                    {props.kind === "warning" ? (
                        <div
                            id="warning"
                            className="bg-[#FFC107] w-[0.3rem] absolute h-4/5 -right-[0rem] rounded-[0.5rem]"
                        ></div>
                    ) : (
                        <div
                            id="negative"
                            className=" bg-[#B00020] w-[0.3rem] absolute h-4/5 -right-[0rem] rounded-[0.5rem]"
                        ></div>
                    )}
                    <div className=" flex flex-row justify-start items-start">
                        <div className=" max-w-[2.4rem]">
                            <AiOutlineClose
                                className=" text-[24px] text-[#21212199] cursor-pointer"
                                onClick={() => props.setShow(props.id)}
                            />
                        </div>

                        <p className=" text-[#21212199] font-normal text-[1.4rem] leading-[2.4rem] mr-[2.1rem]">
                            {props.children}
                        </p>
                    </div>
                </div>
            </div>
        )
    );
}

export default Notification;
